import Make from './../components/MakeSection/Make';
import Titles from '../components/Titles/Titles';
import Philosophy from '../components/CareersPage/Philosophy';
import Positions from '../components/CareersPage/Positions';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const Careers = () => {
    const seo = usePageSEO('careers');

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                type={seo.type}
                noIndex={seo.noIndex}
                noFollow={seo.noFollow}
            />
            <Titles page="CareersPage" />
            <Philosophy />
            <Positions />
            <Make pageKey='careersPage' />
        </>
    );
};

export default Careers;